import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";

import { Content } from "../../../../../../../features/dashboard/pedidos/editar/$id/components/EditOrderContent";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Editar pedido" from="/dashboard/pedidos/$id">
      <Content />
    </BaseEditCreateModal>
  );
}
